
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Eine Daumenregel besagt: Mit steigender Körpergrösse sinkt das Schlafbedürfnis. Viele der Kurzschläfer unter den Tieren schlafen in kurzen Phasen oft im Stehen. Zu den Tieren mit dem kürzesten Schlaf zählen etwa:`}</p>
    <table>
  <tbody>
    <tr>
      <td>Okapi</td>
      <td> 5 Minuten</td>
    </tr>
    <tr>
      <td>Giraffe</td>
      <td>1 bis 2 Stunden</td>
    </tr>
    <tr>
      <td>Elefant</td>
      <td>2 bis 3 Stunden</td>
    </tr>
    <tr>
      <td>Wespe</td>
      <td>2 bis 3 Stunden</td>
    </tr>
    <tr>
      <td>Pferd</td>
      <td>2 bis 5 Stunden</td>
    </tr>
    <tr>
      <td>Kuh</td>
      <td>4 Stunden</td>
    </tr>
    <tr>
      <td>Ameise</td>
      <td> 4 bis 5 Stunden</td>
    </tr>
    <tr>
      <td>Ameisenköniging</td>
      <td>9 Stunden</td>
    </tr>
  </tbody>
    </table><br />
    <p>{`Durchschlafen, ungestört? Diesen Genuss kennen Elefanten nicht. Im Schnitt schlafen sie gerade einmal zwei Stunden pro Nacht – zerbröselt in zahlreiche, oft nur wenige Minuten andauernde Einheiten. Die Schlafgewohnheiten im Tierreich sind vielfältig. Ob zwei oder zwanzig Stunden, ob im Stehen, in einem gemütlichen Nest liegend oder kopfüber von der Decke baumelnd, während des Fluges oder unter Wasser, mit offenen oder mit geschlossenen Augen: Zur Ruhe kommen kann man auf viele verschiedene Arten. Doch nicht nur für Menschen gilt: Üppig bemessene Ruhephasen sind ein Luxus. `}<M mdxType="M">{`Viele Tiere können sich Schlaf nur leisten, wenn gerade nichts Dringenderes ansteht.`}</M>{` Wer wie ein Afrikanischer Elefant mehrere Tonnen wiegt und von Grünzeug satt werden will, den beschäftigt allein das Fressen die meiste Zeit des Tages. Das gilt auch für Giraffen, die sich als Wiederkäuer ihrer Nahrung besonders zeitintensiv widmen. Gleichzeitig müssen die Pflanzenfresser stets fürchten, selbst zum Futter von Raubtieren zu werden. `}<br /><br />{`
Vor allem Fluchttiere müssen mit kurzen Schlafzeiten vorliebnehmen. Sie bleiben stets in Alarmbereitschaft und schlafen auch stehend. `}<M mdxType="M">{`Das Okapi kommt mit einer Schlafdosis von nur fünf Minuten pro Tag aus.`}</M>{` Dabei fällt die Waldgiraffe rund zehnmal in den Tiefschlaf, diese Phasen dauern aber lediglich 30 Sekunden. Daneben verbringt das Okapi bis zu sechs Stunden auf seinem Nachtlager mit Dösen. `}<br /><br />{`
Fliegen, Libellen, Krebse, Schlangen und Fische besitzen keine beweglichen Augenlider und schlafen daher mit offenen Augen. Russische Schlafforscher entdeckten, `}<M mdxType="M">{`dass Delfine jeweils nur mit einer Hirnhälfte schlafen und stets ein Auge geöffnet halten.`}</M>{` Der sogenannte Halbhirnschlaf wechselt nach ein bis zwei Stunden die Seite, und die ausgeruhte Hirnhälfte wird wieder aktiviert. Dabei schwimmen die Meeressäuger ganz normal im Wasser und können auch regelmässig zum Luftholen an die Wasseroberfläche aufsteigen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;